/**
 * Normalizes a shareable URL (dev/staging/partner replacements).
 */
export function normalizeShareableLink(link: string): string {
  let out = link;
  if (out.includes("localhost:5183")) {
    out = out.replace("localhost:5183", "localhost:5173");
  }
  if (out.includes("partner.advizehub.com")) {
    out = out.replace("partner.advizehub.com", "students.advizehub.com");
  }
  if (out.includes("staging-partner")) {
    out = out.replace("staging-partner", "staging");
  }
  return out;
}

/**
 * Builds a shareable link: normalizes the URL and optionally appends ?partner=slug.
 */
export function buildShareableLink(
  link: string,
  options?: { partnerSlug?: string | null },
): string {
  let out = normalizeShareableLink(link);
  if (options?.partnerSlug) {
    out = `${out}${out.includes("?") ? "&" : "?"}partner=${options.partnerSlug}`;
  }
  return out;
}

function getOrigin(): string {
  return typeof window !== "undefined" ? window.location.origin : "";
}

export function getPlaylistLink(
  playlistId: string,
  options?: { propsLink?: string; origin?: string },
): string {
  return (
    options?.propsLink ||
    `${options?.origin ?? getOrigin()}/playlists/${playlistId}`
  );
}

export function getAssignmentLink(
  assignmentId: string,
  options?: { origin?: string },
): string {
  return `${options?.origin ?? getOrigin()}/assignments/${assignmentId}`;
}
